import React from 'react';
import Box from '@mui/material/Box';
import StatusChipFinanceiro from './StatusChipFinanceiro';

// Puramente apresentacional — nenhum import de service, nenhum hook de consulta, nenhum cliente
// Apollo (ai/architecture.core.md §3.3/§5). Não calcula nada: recebe as contagens já prontas de
// quem tem os dados (a page — ReembolsosTab, Task 5 do plano). Uma pílula por status, reusando
// StatusChipFinanceiro para a cor e o rótulo (financeiro-dashboard-atleta Phase 5, Task 2).

export interface ContagemStatus {
  status: string;
  total: number;
}

export interface ContadoresStatusProps {
  contagens: ContagemStatus[];
}

const ContadoresStatus: React.FC<ContadoresStatusProps> = ({ contagens }) => {
  return (
    <Box display="flex" flexWrap="wrap" gap={2} mb={3}>
      {contagens.map((contagem) => (
        <Box
          key={contagem.status}
          data-testid={`contador-status-${contagem.status}`}
          display="flex"
          alignItems="center"
          gap={1}
        >
          <StatusChipFinanceiro status={contagem.status} />
          <Box component="span" fontWeight="bold">
            ({contagem.total})
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default ContadoresStatus;
